<template>
  <div v-for="(orderItem, index) in orderItems" v-bind:key="index">
    <q-expansion-item switch-toggle-side default-opened :label="orderLabel(orderItem)">
      <div class="bg-warning default-border-radius mb-2 p-2 text-white">
        <LabelAndValue
            :i18n-key="'summaryPanel.asset.total'"
            :value="`${formatWithMask(getTotalAllAssets(orderItem.orderAssets), 2)}  €`"
            :oneLine="true"
            :label-style="'text-white'"
            :value-style="valueStyleTotal"
            :div-value-style="'d-flex justify-between'"
        />
      </div>
      <div v-for="(item, index) in orderItem.orderAssets?.filter(item => item.assetTradeIn === null)" v-bind:key="index" class="">
        <div class="bg-secondary default-border-radius p-2 tw-items-dashed-group">
          <LabelAndValue
              :i18n-key="`Asset ${(index + 1)}`"
              :value="`${formatWithMask(totalPriceWithTax(orderItem.orderAssets, index), 2)}  €`"
              :oneLine="true"
              :label-style="'text-primary'"
              :value-style="'text-primary'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemBar"
              :i18n-key="'good.goodDetails.goodGeneralInfo.generalInformations'"
              :value="''"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'order.item.generalInfo.from'"
              :value="getselectedAssetFrom(item)"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'summaryPanel.asset.quantite'"
              :value="item.quantity"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'demand.asset.vehicle.brand'"
              :value="getBrand(item.brand)"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'demand.asset.vehicle.model'"
              :value="getModel(item)"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'summaryPanel.asset.description'"
              :value="item.description"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'summaryPanel.asset.asset'"
              :value="`${formatWithMask(item.totalAmountWTax?.amount || 0, 2)}  €`"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'demand.asset.matriculation'"
              :value="item.matriculation ? item.matriculation : '-'"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'demand.asset.matriculationDate'"
              :value="item.matriculationDate ? item.matriculationDate : '-'"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'demand.asset.constructionDate'"
              :value="item.constructionDate ? item.constructionDate : '-'"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemBar"
              :i18n-key="'demand.asset.characteristics'"
              :value="''"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'demand.asset.doorsNumber'"
              :value="item.nbOfDoor ? item.nbOfDoor : '-'"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'demand.asset.numberOfSeats'"
              :value="item.nbOfSeat ? item.nbOfSeat : '-'"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'good.goodDetails.goodFeatures.Motorization.NumberOfCylinders'"
              :value="item.nbOfCylinder ? item.nbOfCylinder : '-'"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'demand.asset.gearType'"
              :value="item.gearBox ? item.gearBox : '-'"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'demand.asset.horsePower'"
              :value="item.horsePower ? item.horsePower : '-'"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'demand.asset.taxHorsePower'"
              :value="item.taxHorsePower ? item.taxHorsePower : '-'"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'demand.asset.bodywork'"
              :value ="getbodywork(item)"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'demand.asset.chassisReference'"
              :value="item.chassisReference ? item.chassisReference : '-'"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'demand.asset.nbOfGear'"
              :value="item.nbOfGear ? item.nbOfGear : '-'"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'demand.asset.currentMileage'"
              :value="item.currentMileage ? item.currentMileage : '-'"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'demand.asset.length'"
              :value="item.vehicleLength ? item.vehicleLength : '-'"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'demand.asset.color'"
              :value="getColor(item)"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />

          <LabelAndValue
              class="itemBar"
              :i18n-key="'summaryPanel.asset.totalFrais'"
              :value="`${formatWithMask(proposalAssetItemsTotalWithTax(orderItem.orderAssets, index), 2)}  €`"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />

          <LabelAndValue
              class="itemsBar"
              :i18n-key="'summaryPanel.asset.options'"
              v-if="proposalAssetOptionItems.length"
              :value="`${formatWithMask(proposalAssetOptionItemsTotalWithTax(orderItem.orderAssets, index), 2)}  €`"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />

          <LabelAndValue
              class="itemsBar"
              :i18n-key="'summaryPanel.asset.options'"
              v-if="!proposalAssetOptionItems.length"
              :value="`${formatWithMask(0, 2)}  €`"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />

          <LabelAndValue
              class="itemsBar"
              :i18n-key="'summaryPanel.asset.accessories'"
              v-if="proposalAssetAccessoryItems.length"
              :value="`${formatWithMask(proposalAssetAccessoryItemsTotalWithTax(orderItem.orderAssets, index), 2)}  €`"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />
          <LabelAndValue
              class="itemsBar"
              :i18n-key="'summaryPanel.asset.accessories'"
              v-if="!proposalAssetAccessoryItems.length"
              :value="`${formatWithMask(0, 2)}  €`"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />

          <LabelAndValue
              class="itemsBar"
              :i18n-key="'summaryPanel.asset.fairsDivers'"
              v-if="proposalAssetOtherItems.length"
              :value="`${formatWithMask(proposalAssetOtherItemsTotalWithTax(orderItem.orderAssets, index), 2)}  €`"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />

          <LabelAndValue
              class="itemsBar"
              :i18n-key="'summaryPanel.asset.fairsDivers'"
              v-if="!proposalAssetOtherItems.length"
              :value="`${formatWithMask(0, 2)}  €`"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />

          <LabelAndValue
              class="itemsBar"
              :i18n-key="'summaryPanel.asset.services'"
              v-if="proposalAssetOtherItems.length"
              :value="`${formatWithMask(proposalAssetServicesTotalWithTax(orderItem.orderAssets, index), 2)}  €`"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />

          <LabelAndValue
              class="itemsBar"
              :i18n-key="'summaryPanel.asset.services'"
              v-if="!proposalAssetOtherItems.length"
              :value="`${formatWithMask(0, 2)}  €`"
              :oneLine="true"
              :label-style="'text-dark'"
              :div-value-style="'d-flex justify-between'"
          />


        </div>
      </div>
    </q-expansion-item>
  </div>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";
import LabelAndValue from "@/components/general/LabelAndValue.vue";
import {formatWithMask} from "@/utils/configuration/formatters-config";
import {OrderItem, OrderProposalAssetItemType} from "@/types";
import store from "@/store";
import i18n from "@/i18n";
import { initOrders } from "@/store/services/order/orderMapper";

@Options({
  methods: { formatWithMask },
  components: { LabelAndValue },
  props: [],
})
export default class OrderSummaryAsset extends Vue {

  option = OrderProposalAssetItemType.option;
  other = OrderProposalAssetItemType.others;
  accessory = OrderProposalAssetItemType.accessory;

  get orderItems() {
   
       return store.state.summaryPanelModule.order?.orderItems || []
  }

  orderLabel(ordemItem: OrderItem) {
    return ordemItem.reference
  }

  getTotalAllAssets(assets: any) {
    let totalAssets = 0;
    for (let i = 0; i <= assets.length - 1; i++) {
      totalAssets += this.totalPriceWithTax(assets, i);
    }
    return totalAssets;
  }

  assetItem(assets: any, index: number) {
    return assets[index];
  }

  totalPriceWithTax(assets: any, index: number) {
    const totalAmountWTax = this.assetItem(assets, index)
        ? this.assetItem(assets, index).totalAmountWTax?.amount || 0
        : 0;
    return this.proposalAssetItemsTotalWithTax(assets, index) + totalAmountWTax || 0;
  }

  proposalAssetItems(assets: any, index: number) {
    return this.assetItem(assets, index) ? assets[index].orderAssetComponents || [] : [];
  }
  proposalAssetItemsTotalWithTax(assets: any, index: number) {
    return this.proposalAssetItems(assets, index)
        .filter((item: any) => item)
        .reduce((a: number, b: any) => {
          return a + (b.totalAmountWTax?.amount || 0);
        }, 0) +this.proposalAssetServicesTotalWithTax(assets, index) ;
  }

  proposalAssetOptionItems(assets: any, index: number) {
    return (this.assetItem(assets, index).orderAssetComponents || []).filter(
        (item: any) => item.type?.resourceUid || item.type === this.option
    );
  }

  proposalAssetOptionItemsTotalWithTax(assets: any, index: number) {
    return this.proposalAssetOptionItems(assets, index)
        .filter((item: any) => item)
        .reduce((a: number, b: any) => {
          return a + (b.totalAmountWTax?.amount || 0);
        }, 0);
  }

  proposalAssetAccessoryItems(assets: any, index: number) {
    return (this.assetItem(assets, index).orderAssetComponents || []).filter(
        (item: any) => item.type?.resourceUid  || item.type === this.accessory
    );
  }
  proposalAssetAccessoryItemsTotalWithTax(assets: any,index: number) {
    return this.proposalAssetAccessoryItems(assets, index)
        .filter((item: any) => item)
        .reduce((a: number, b: any) => {
          return a + (b.totalAmountWTax?.amount || 0);
        }, 0);
  }
  proposalAssetOtherItems(assets: any, index: number) {
    return (this.assetItem(assets, index).orderAssetComponents || []).filter(
        (item: any) => item.type?.resourceUid  || item.type === this.other
    );
  }
  proposalAssetServiceItems(assets: any, index: number) {
    console.log(this.assetItem(assets, index).orderAssetServices)
    return (this.assetItem(assets, index).orderAssetServices || [])
  }
  proposalAssetServicesTotalWithTax(assets: any, index: number) {
    return this.proposalAssetServiceItems(assets, index)
        .filter((item: any) => item)
        .reduce((a: number, b: any) => {
          return a + (b.amountWTax?.amount || 0);
        }, 0);
  }

  proposalAssetOtherItemsTotalWithTax(assets: any, index: number) {
    return this.proposalAssetOtherItems(assets, index)
        .filter((item: any) => item)
        .reduce((a: number, b: any) => {
          return a + (b.totalAmountWTax?.amount || 0);
        }, 0);
  }

  getselectedAssetFrom(item:any) {
      const value = item.assetInventory
      if (value){
        return i18n.global.t("order.asset.selectAssetFrom.inventory")
      }
      else {
        return i18n.global.t("order.asset.selectAssetFrom.catalog")
    }
  }
  getBrand(brand: string) {
    return brand ? brand.replace(/asset.good.vehicle.brand./g, "") : "";
  }
  getCategory(item:any){
    return item.proposalAssetCategories && item.proposalAssetCategories[0]&& item.proposalAssetCategories[0].category&& item.proposalAssetCategories[0].category.value ? i18n.global.t("demand.asset.categoryItems."+item.proposalAssetCategories[0].category.value ): "-"
  }
  getSubCategory(item:any){
    return item.proposalAssetCategories && item.proposalAssetCategories[0]&& item.proposalAssetCategories[0].categoryClass&& item.proposalAssetCategories[0].categoryClass.value ? i18n.global.t("demand.asset.subCategoryItems." + item.proposalAssetCategories[0].categoryClass.value.substring(item.proposalAssetCategories[0].categoryClass.value.lastIndexOf(".") + 1) ): "-"
  }
  getModel(item: any) {
    return item.config && item.config.formBind && item.config.formBind.range && item.config.formBind.range.label ? item.config.formBind.range.label : "-";
  }
  getSupplierName(item: any) {
    return item.config && item.config.supplierPartyName ? item.config.supplierPartyName : "-"
  }
  getSupplierAddress(item: any) {
    return item.assetDelivery && item.assetDelivery.description? item.assetDelivery.description : "-"
  }
  getbodywork(item:any){
    return item.carBodyStyle? i18n.global.t("scales.picklist.category_class."+item.carBodyStyle.replaceAll('.','_') ) :' - '
  }
  getColor(item:any){
    return item.color? item.color :' - '
  }
  
  async created (){
    const orderItems =await initOrders(this.orderItems)
    this.orderItems[0].orderAssets = 
      orderItems && orderItems[0] && orderItems[0].orderAssets
      ? orderItems[0].orderAssets 
      : null
     store.dispatch("summaryPanelModule/calculateOrderProposalAsset", {
      proposalAsset : this.orderItems && this.orderItems[0] && this.orderItems[0].orderAssets && this.orderItems[0].orderAssets[0] ? this.orderItems[0].orderAssets[0] : undefined
    });
  }

  valueStyle = {
    "font-weight": "bold",
    "margin-left": "20px",
    // "color": "black"
  };

  valueStyleTotal = {
    "font-weight": "bold",
    color: "#1976D2",
  };

  divValueStyle = {
    display: "flex",
    "justify-content": "end",
    "padding-right": "0.5rem",
  };

  divValueItem = {
    display: "flex",
    "justify-content": "end",
    "padding-right": "0.5rem",
  };

  divValueItems = {
    display: "flex",
    "justify-content": "end",
    "padding-right": "0.5rem",
  };

  labelStyleTotal = {
    "font-weight": "bold",
    "font-size": "1rem",
    color: "#1976D2",
  };

  labelStyleAsset = {
    "font-weight": "bold",
    "font-size": "1rem",
    color: "black",
  };

  labelStyleItems = {
    "font-weight": "bold",
    "font-size": "1rem",
    color: "gray",
  };
}
</script>

<style scoped>
.totalBar {
  display: flex;
  align-items: center;
  padding: 16px 0 8px 0;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.assetBar {
  display: flex;
  align-items: center;
  padding: 5px 0 5px 0;
}

.itemBar {
  display: flex;
  align-items: center;
  padding: 10px 10px 10px 10px;
}

.itemsBar {
  display: flex;
  align-items: center;
  padding: 0 10px 0 20px;
}

.borderRadius {
  border-radius: 20px;
}
</style>
